import React from 'react';
import styled from 'styled-components';

import device from '../utils/device';

const color = '#fff;';

const Container = styled.nav`
  color: ${color};
  margin: 0 1.6rem;

  display: flex;
  align-items: center;

  @media ${device.desktop} {
    margin: 0 20vw;
  }
`;

const IndexContainer = styled.div`
  text-align: center;
  cursor: pointer;

  :focus {
    outline: 0;
  }
`;

const IndexTtile = styled.div`
  text-transform: uppercase;
  font-size: 0.34rem;
  height: 0.5rem;
  font-family: 'Montserrat';
  font-weight: 800;

  @media ${device.desktop} {
    font-size: 0.6rem;
    height: 1rem;
  }

  @media ${device.bigDesktop} {
    font-size: 0.7rem;
    height: 1.1rem;
  }
`;

const IndexNumber = styled.div`
  background: ${color};
  color: ${({ theme }) => theme.colors.textDark};
  font-face: 'Montserrat';
  font-weight: 900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0.9rem;
  height: 1.65rem;
  width: 1.65rem;

  @media ${device.desktop} {
    font-size: 1.3rem;
    height: 2.3rem;
    width: 2.3rem;
  }

  @media ${device.bigDesktop} {
    font-size: 1.5rem;
    height: 2.5rem;
    width: 2.5rem;
  }
`;

const Title = styled.div`
  font-weight: bold;

  font-size: 1rem;
  margin: 0 0.7rem;
  min-width: 6rem;
  max-width: 10rem;

  @media ${device.desktop} {
    font-size: 1.5rem;
    margin: 0 1.875rem;
    max-width: 28rem;
  }

  @media ${device.bigDesktop} {
    font-size: 1.8rem;
    margin: 0 1.875rem;
    max-width: 30rem;
  }
`;

const Filler = styled.div`
  flex: 1;
  border-bottom: 1px dotted ${color};
  margin: 0 0.4rem;

  @media ${device.desktop} {
    margin: 0 1.875rem;
  }
`;

const BigFiller = styled(Filler)`
  flex: 3;
`;

const Page = ({ number, title, active, last, onClick }) => {
  const icon = (
    <>
      <IndexContainer onClick={onClick} tabIndex={number} role="button">
        <IndexTtile>Video</IndexTtile>
        <IndexNumber>{number}</IndexNumber>
        <IndexTtile />
      </IndexContainer>
    </>
  );

  if (last) {
    if (active) {
      return (
        <>
          {icon}
          <Title>{title}</Title>
        </>
      );
    }

    return icon;
  }

  if (active) {
    return (
      <>
        {icon}
        <Title>{title}</Title>
        <BigFiller />
      </>
    );
  }

  return (
    <>
      {icon}
      <Filler />
    </>
  );
};

const VideoPager = ({ videos, active, setActive }) => {
  return (
    <Container>
      {videos.map((v, i) => (
        <Page
          key={v.id}
          number={v.id}
          title={v.shortTitle}
          active={v.id === active}
          last={i === videos.length - 1}
          onClick={() => setActive(v.id)}
        />
      ))}
    </Container>
  );
};

export default VideoPager;
